import styles from '../styles/details/id.module.scss';
import itemStyles from '../../components/styles/Item.module.scss';
import React, { useEffect, useState } from 'react'
import { Button, Row, Col, Tag, PageHeader, Descriptions, message } from 'antd';
import { Star, PreviewOpen, Time, ArrowRight, CategoryManagement } from '@icon-park/react';
import { getItem, isLike } from '../../constants/api'
import { http } from '../../utils/api'
import Layout from '../../components/MyLayout'
import Item from '../../components/Item/link'
import { Item as item } from '../../@types/index'
import { NextPage, NextPageContext } from 'next';
import { useSelector } from 'react-redux';
import { State } from '../../@types/reducer';
import Link from 'next/link';
import { deleteHtmlTag, limitWords } from '../../utils';
import { pattern, title } from '../../constants/heads';
import NoSsr from '../../components/NoSsr';

type Props = {
    data: {
        data: any
        imgUrl: string
        minImgUrl: string
        list: any
    }
}

const Details: NextPage<Props> = (props) => {
    const baseUrl = useSelector((state: State) => state.baseUrl)
    const [statu, setStatu] = useState(props.data.data.like_status);
    const [like, setLike] = useState(props.data.data.like);
    const { data, imgUrl, list, minImgUrl } = props.data
    const { isXs, isSm, isMd, isXxl } = useSelector((state: State) => state.responsive)
    const head = {
        title: `${data.title}${data.brief ? "-" + data.brief : ""}-${title}`,
        description: limitWords(deleteHtmlTag(data.content), 200),
        keywords: `${data.title},${data.title}官网,${data.title}网址`
    }

    const likeFun = async (id: string) => {
        let res: any = await http(isLike, { id })
        if (res.code == 200) {
            if (res.data.num == 1) {
                setLike(like + 1)
                setStatu(true)
                message.success('收藏成功');
            } else {
                setLike(like - 1)
                setStatu(false)
            }
        }
    }

    const linkFun = (id: string) => {
        location.href = `/api/link?id=${id}`
    }

    const keyword = ['', '官网', '网址']

    useEffect(() => {
        const regexp = /\.(sogou|soso|baidu|google|youdao|yahoo|bing|so|biso|gougou|ifeng|ivc|sooule|niuhu|biso)(\.[a-z0-9\-]+){1,2}\//ig;
        const where = document.referrer;
        if (regexp.test(where) && data.new_label) {
            location.href = baseUrl
            return
        }
    }, []);

    return (
        <Layout head={head} styles={['/css/github.css', '/css/github-markdown.css']} scripts={['/js/content-protector.min.js']}  className={styles.details}>
            <div className="content" style={{ paddingTop: '10px' }}>
                <PageHeader
                    title={data.title}
                    subTitle={isXs ? '' : data.brief}
                    avatar={{ src: imgUrl + data.logo, size: isXs ? 35 : 50 }}
                    extra={[
                        <NoSsr key="1" >
                            <Button onClick={() => { likeFun(data._id) }} icon={
                                <Star theme={statu ? "filled" : "outline"} size="14" fill={statu ? '#ffdf29' : "#999"} strokeWidth={3} strokeLinejoin="miter" />
                            }>&nbsp;{like}
                            </Button>
                        </NoSsr>
                        ,
                        <NoSsr key="2" >
                            <Button type="primary" onClick={() => { linkFun(data._id) }}>
                                立即访问&nbsp;
                                <ArrowRight theme="outline" size="16" fill="#fff" strokeWidth={3} strokeLinejoin="miter" strokeLinecap="butt" />
                            </Button>
                        </NoSsr>

                    ]}
                    footer={
                        <div className="markdown-body works-cont">
                            <div dangerouslySetInnerHTML={{ __html: data.content }}></div>
                        </div>
                    }
                >
                    <div className="main">{
                        <Descriptions size="small" column={isXs ? 2 : 3}>
                            <Descriptions.Item label="分类">
                                <Link href={`/details/category?c=${data.category}`} >
                                    <a target="_blank" title={`${data.category_name}`} >
                                        <NoSsr> <CategoryManagement theme="outline" size="18" fill="#999" strokeWidth={3} strokeLinejoin="miter" /> </NoSsr>{data.category_name}
                                    </a>
                                </Link>
                            </Descriptions.Item>
                            <Descriptions.Item label="标签">{data.label.map((item: string, index: number) => (<Tag key={index}>{item}</Tag>))}</Descriptions.Item>
                            <Descriptions.Item label="时间" span={isXs ? 2 : 3}><NoSsr> <Time theme="outline" size="16" fill="#999" strokeWidth={3} strokeLinejoin="miter" /></NoSsr>&nbsp;{data.creat_date}</Descriptions.Item>
                            <Descriptions.Item label="查看"><NoSsr> <PreviewOpen theme="outline" size="18" fill="#999" strokeWidth={3} strokeLinejoin="miter" /></NoSsr>&nbsp;{data.visit}</Descriptions.Item>
                            <Descriptions.Item label="收藏"><NoSsr> <Star theme="outline" size="18" fill="#999" strokeWidth={3} strokeLinejoin="miter" /></NoSsr>&nbsp;{like}</Descriptions.Item>
                        </Descriptions>
                    }</div>
                </PageHeader>
            </div>
            {data.screenshot &&
                <Link href={`/nav/${data._id}`} >
                    <a title={data.title} className="text" target="_blank">
                        <div className="content">
                            <img
                                src={`${baseUrl}/file/screenshots/${data._id}.png`}
                                title={`${data.title}-${data.brief}`}
                            />
                        </div>
                    </a>
                </Link>
            }
            <div className={itemStyles.item} >
                <h3>相关推荐</h3>
                {list.map((item: item, index: number) => {
                    return (
                        <Item isLazyLoad switch={{ icon: true, tag: true, brief: true, data: true }} imgUrl={minImgUrl} key={index} data={item} />
                    )
                })}
            </div>
            <Row className="content">
                <Col span={24} style={{ paddingBottom: '10px' }}>关键词：
                    {keyword.map((v, k) => (
                        <Tag key={k}>
                            <a target="_blank" href={`/details/${pattern ? data._id : data.pinyin}`}>{data.title}{v}</a>
                        </Tag>
                    ))}
                </Col>
                <Col span={24}>网站标签：
                    {data.participle.map((v: string, k: number) => (
                        <Tag key={k}>
                            <a>{v}</a>
                        </Tag>)
                    )}
                </Col>
            </Row>
        </Layout>
    )
}

Details.getInitialProps = async ({ req, res, err, query }: NextPageContext) => {
    const data: any = await http(getItem, { id: query.id }, req)
    // if (data.code != 200) {
    //     res.writeHead(404)
    //     res.end()
    // }
    if (data.code != 200 && res) {
        res.writeHead(404)
        res.writeHead(301, { location: '/404' })
        res.end()
    }
    return { data: data }
}

export default Details